<template>
  <!-- 反馈管理 -->
  <div>
    <el-dialog
      :before-close="handleClose"
      :close-on-click-modal="false"
      title="反馈管理"
      :visible.sync="dialogVisible"
      width="851px"
      :append-to-body="true"
    >
      <div class="dialogContent">
        <div class="search">
          <div class="searchLeft">
            <el-select
              v-model="formData.appealState"
              class="ccui-form-longInput"
              placeholder="全部状态"
              filterable
              :popper-append-to-body="false"
            >
              <el-option
                v-for="item in appealStatusOptions"
                :key="item.dicKey"
                :label="item.dicValue"
                :value="item.dicKey"
              ></el-option>
            </el-select>
            <el-date-picker
              style="margin-right: 10px;"
              v-model="formData.value1"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
            <button class="custom-button" @click="handleSearch">
              查询
            </button>
          </div>
          <div class="searchRight">
            <button class="add-button" @click="handleNewAdd">
              新增反馈
            </button>
          </div>
        </div>
        <div class="ccui-multifunctional-table-wrapper">
          <el-table
            :data="tableData"
            :fit="true"
            border
            min-height="269px"
            class="ccui-multifunctional-table"
            :cell-style="cellStyle"
            @cell-click="cellClick"
            :header-cell-style="{ backgroundColor: '#EFF3FA' }"
          >
            <el-table-column label="序号" width="50" fixed>
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <template v-for="(table, index) in tableTheadOptions">
              <el-table-column
                :fixed="table.fixed || false"
                :key="index"
                :type="table.type"
                :label="table.label"
                :min-width="table.width"
                :prop="table.prop"
                :align="table.align || 'left'"
                :header-align="table.headerAlign || 'left'"
                :filters="table.filters"
                show-overflow-tooltip
              >
              </el-table-column>
            </template>
          </el-table>
        </div>
      </div>
      <!-- 申请反馈 -->
      <AppealFeedbackDialog
        ref="appealFeedbackDialog"
        :supCode="supCode"
        :type="type"
      />
    </el-dialog>
  </div>
</template>

<script>
import { getSupAppealFeedbackList } from "../api";
import AppealFeedbackDialog from "./appealFeedbackDialog.vue";
import { exportFiles } from "@/basa/utils/public";
export default {
  name: "feedbackManagement",
  components: {
    AppealFeedbackDialog
  },
  props: {
    reviewId: {
      type: String,
      default: () => ""
    },
    supCode: {
      type: String,
      default: () => ""
    },
    type: {
      type: String,
      default: () => ""
    }
  },
  data() {
    return {
      dialogVisible: false,
      formData: {
        appealState: "0",
        value1: ""
      },
      localSearchData: {
        appealState: "0"
      },
      tableData: [],
      appealStatusOptions: [
        {
          dicKey: "0",
          dicValue: "全部"
        },
        {
          dicKey: "1",
          dicValue: "处理中"
        },
        {
          dicKey: "2",
          dicValue: "申诉成功"
        },
        {
          dicKey: "3",
          dicValue: "申诉失败"
        }
      ],
      tableTheadOptions: [
        {
          label: "申诉类型",
          prop: "appealTypeStr",
          width: "100"
        },
        {
          label: "申诉标题",
          prop: "appealTitle",
          width: "100"
        },
        {
          label: "申诉理由及详情",
          prop: "remark",
          width: "100"
        },
        {
          label: "申诉时间",
          prop: "createTime",
          width: "150"
        },
        {
          label: "申诉状态",
          prop: "appealStateStr",
          width: "100"
        },
        {
          label: "相关材料证明",
          prop: "file",
          width: "100"
        },
        {
          label: "反馈结果",
          prop: "feedbackResult",
          width: "100"
        }
      ]
    };
  },
  watch: {
    dialogVisible: {
      handler(newVal) {
        if (newVal) {
          this.getList();
        }
      }
    }
  },
  activated() {},
  methods: {
    getList(reqObj) {
      let obj = typeof reqObj == "object" ? reqObj : {};
      obj = {
        ...this.localSearchData,
        supCode: this.supCode,
        reviewTaskId: this.reviewId
      };
      obj.appealState = obj.appealState === "0" ? "" : obj.appealState;
      getSupAppealFeedbackList(obj)
        .then(res => {
          this.tableData = res.data.data;
          if (this.tableData.length) {
            this.tableData.forEach(item => {
              switch (item.appealType) {
                case 1:
                  item.appealTypeStr = "准入审核申诉";
                  break;
                case 9:
                  item.appealTypeStr = "问题反馈";
                  break;
              }
              switch (item.appealState) {
                case 0:
                  item.appealStateStr = "待处理";
                  break;
                case 1:
                  item.appealStateStr = "处理中";
                  break;
                case 2:
                  item.appealStateStr = "申诉成功";
                  break;
                case 3:
                  item.appealStateStr = "申诉失败";
                  break;
              }
              if (item.attachmentList.length) {
                item.file = "下载";
              }
            });
          }
        })
        .catch(err => {});
    },
    handleSearch() {
      this.localSearchData = JSON.parse(JSON.stringify(this.formData));
      if (this.localSearchData.value1 && this.localSearchData.value1.length) {
        this.localSearchData.createTimeStart = this.localSearchData.value1[0];
        this.localSearchData.createTimeEnd = this.localSearchData.value1[1];
      }
      delete this.localSearchData.value1;
      this.getList(this.localSearchData);
    },
    // 新增
    handleNewAdd() {
      this.$refs["appealFeedbackDialog"].dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
      this.formData = {};
    },
    // 根据返回状态显示不同的文字颜色
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (["file"].includes(column?.property)) {
        return { color: "#0089EF", cursor: "pointer" };
      }
    },
    // 下载
    cellClick(row, column, columnIndex) {
      if (column.property == "file") {
        let obj = {
          downLoadFileBOList: row.attachmentList
        };
        // 批量导出
        exportFiles(obj);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.search {
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
}
.custom-button {
  width: 55px;
  height: 26px;
  background: #006eff;
  border-radius: 4px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #ffffff;
  border: none;
}
.el-select {
  width: 160px;
  margin-right: 10px;
}
.add-button {
  width: 74px;
  height: 26px;
  background: #006eff;
  border-radius: 4px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #ffffff;
  border: none;
}
</style>
